import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const stateClassNames = (prefix, active, disabled, link) => {
  let className = '';
  if (active) {
    className += ` ${prefix}--active `;
  }
  if (disabled) {
    className += ` ${prefix}--disabled `;
  }
  if (link) {
    className += ` ${prefix}--link `;
  }
  return className;
};

const Arrow = () => (
  <div className="breadcrumb breadcrumb__arrow">
    <i className="fas fa-arrow-right" />
  </div>
);
const BreadcrumbContent = ({ step, text, active, disabled, link }) => (
  <div className="breadcrumb-content">
    <div
      className={`breadcrumb-content__step ${stateClassNames(
        'breadcrumb-content__step',
        active,
        disabled,
        link,
      )}`}
    >
      <div className="breadcrumb-content__step-number">{step}</div>
    </div>
    <div
      className={`breadcrumb-content__text ${stateClassNames(
        'breadcrumb-content__text',
        active,
        disabled,
        link,
      )}`}
    >
      {text}
    </div>
  </div>
);
BreadcrumbContent.propTypes = {
  step: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  link: PropTypes.string,
};
BreadcrumbContent.defaultProps = {
  link: null,
};

const Breadcrumb = ({ step, text, active, disabled, link }) => (
  <div
    className={`breadcrumb ${stateClassNames(
      'breadcrumb',
      active,
      disabled,
      link,
    )}`}
  >
    {(link && (
      <Link
        to={link}
        className={`breadcrumb__entry ${stateClassNames(
          'breadcrumb__entry',
          active,
          disabled,
          link,
        )}`}
      >
        <BreadcrumbContent {...{ step, text, active, disabled, link }} />
      </Link>
    )) || (
      <div
        className={`breadcrumb__entry ${stateClassNames(
          'breadcrumb__entry',
          active,
          disabled,
          link,
        )}`}
      >
        <BreadcrumbContent {...{ step, text, active, disabled, link }} />
      </div>
    )}
  </div>
);
Breadcrumb.propTypes = BreadcrumbContent.propTypes;

const Breadcrumbs = ({ breadcrumbs }) => (
  <div className="container breadcrumbs__container">
    <div className="row breadcrumbs__row">
      <div className="col">
        {breadcrumbs.map(({ step, text, active, disabled, link }, i) => (
          <div key={step} className="breadcrumbs__col">
            <Breadcrumb {...{ step, text, active, disabled, link }} />
            {i < breadcrumbs.length - 1 && <Arrow />}
          </div>
        ))}
      </div>
    </div>
  </div>
);
Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.arrayOf(PropTypes.shape(Breadcrumb.propTypes))
    .isRequired,
};

export default Breadcrumbs;
